// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"StyledBreadcrumbs_breadcrumbs__19_1B","breadcrumbsItem":"StyledBreadcrumbs_breadcrumbsItem__1QjpT"};